import { Mesh, TextureLoader } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/tema3/GLB_Panera02.glb"
import { GUI } from "dat.gui";
import { textureActivityTheme3 } from "../../../../../assets/tema3/activity";


const imgTextureVitrina = {
	p1: textureActivityTheme3.topic1.act1.paneara.p1,
	p2: textureActivityTheme3.topic1.act1.paneara.p2,
	p3: textureActivityTheme3.topic1.act1.paneara.p3,
	p4: textureActivityTheme3.topic1.act1.paneara.p4,
	p5: textureActivityTheme3.topic1.act1.paneara.p5,
}

export class BreadStation extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.scale.set(2, 2, 2);

		this.nameTexture = {
			p1: "p1",
			p2: "p2",
			p3: "p3",
			p4: "p4",
			p5: "p5",
		}
		// this.rotation.y = MathUtils.degToRad(90)
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);

			this.Vitrina_Panera = gltf.scene.getObjectByName("Vitrina_Panera", true);

			this.updateMaterialVitrina(imgTextureVitrina.p1)
		});
	}

	updateMaterialVitrina(img) {
		const newTexture = new TextureLoader().load(img);
		this.Vitrina_Panera.material.map = newTexture
	}

	onChangueTextureVitrina(name = "") {
		const imgTexture = imgTextureVitrina[name]
		if (!imgTexture) {
			return
		}
		this.updateMaterialVitrina(imgTexture)
	}

	helpers() {
		const gui = new GUI();
		const premiaFolder = gui.addFolder("Panes");
		premiaFolder.add(this.position, "x", -20, 20).step(0.0001).name("Posición X");
		premiaFolder.add(this.position, "y", -20, 20).step(0.0001).name("Posición Y");
		premiaFolder.add(this.position, "z", -20, 20).step(0.0001).name("Posición Z");
		premiaFolder.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		premiaFolder.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		premiaFolder.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		premiaFolder.add(this, "visible").name("Visible");
	}




	renderAnimations() { }
}
